<div class="one-way-route-picker">
  <idp-book-widget-search-modal-mach-core
    [recentSearchList]="recentSearchList"
    [savedSearchList]="savedSearchList"
    [searchModalTabs]="searchModalTabs"
    [predictiveSearchData]="predictiveSearchData"
    [isFullscreen]="isFullscreen"
    [modalOpen]="modalOpen"
    (searchModalClose)="handleSearchModalClose($event)"
    (selectedTabChange)="handleModalEvents({ type: 'tabChange', data: $event })"
    (searchStringChanged)="
      handleModalEvents({ type: 'searchStringChanged', data: $event })
    "
    (savedSearchItemSelected)="
      handleModalEvents({ type: 'saveSearchItemSelected', data: $event })
    "
    (recentSearchItemSelected)="
      handleModalEvents({ type: 'recentSearchItemSelected', data: $event })
    "
    (predictiveSearchItemSelected)="handlePredictiveSearchItemSelection($event)"
  >
    <div
      [id]="elementId"
      class="from-and-to"
      [idpErrorState]="!!errorMessage"
    ></div>
  </idp-book-widget-search-modal-mach-core>
  <div
    class="one-way-route-picker--error-msg mt-[8px] text-caption-medium text-alert"
    *ngIf="errorMessage"
  >
    {{ errorMessage }}
  </div>
</div>
